import {
  AssetType,
  BatteryDataType,
  MotorDataType,
  OptimizationParameterValue,
  PVSystemDataType,
} from '@e2m-customer-portal/domains';

export const getDefaultBatteryData = (data: BatteryDataType) => ({
  ...data,
});

export const getDefaultMotorData = (data: MotorDataType) => ({ ...data });

export const getDefaultPVData = (data: PVSystemDataType) => ({ ...data });

const purgeItems = (items: Map<string, Map<string, OptimizationParameterValue>>) =>
  Array.from(items).filter(([_key, value]) => value.size > 0);

export const getAssetConfiguration = (
  assetType: AssetType,
  items: Map<string, Map<string, OptimizationParameterValue>>,
  PVItems?: Map<string, Map<string, OptimizationParameterValue>>,
) => {
  const purgedItems = purgeItems(items);
  const purgedPVItems = PVItems && purgeItems(PVItems);

  const updatedItems = Object.fromEntries(Array.from(purgedItems, ([key, value]) => [key, Object.fromEntries(value)]));

  const updatedPVItems =
    purgedPVItems && Object.fromEntries(Array.from(purgedPVItems, ([key, value]) => [key, Object.fromEntries(value)]));

  switch (assetType) {
    case AssetType.InnoTender:
    case AssetType.InnoTenderGE:
      return { battery: updatedItems[0] };
    case AssetType.FleximumBatteries:
    case AssetType.PeakShavingBatteries:
    case AssetType.AFRRBatteries:
      return { batteries: updatedItems };
    case AssetType.CoLocation:
      return { pv: updatedPVItems, batteries: updatedItems };
    default:
      return { motors: updatedItems };
  }
};
